import { InitCookie } from '@patsnap/init-cookie';
import { getAgentNameByRoute } from './agent-name';
import { getVar } from './environment';

export class InitCookieService {
    initCookieIns = new InitCookie({
        entry_channel: this.getEntryChannel(),
    });
    /**
     * 用户最初进入的页面或入口
     */
    getEntryChannel() {
        return this.getAgentName();
    }
    /**
     * 优先使用 URL 中显式传入的 product_source 定位具体 Agent，
     * 未传时再根据当前路由推导 Agent 名称。
     * @returns
     */
    productSource() {
        return getVar('product_source') || this.getAgentName();
    }

    async init() {
        return this.initCookieIns.init();
    }

    /**
     * 根据路由获取agent名称
     * @returns
     */
    getAgentName() {
        return getAgentNameByRoute();
    }

    /**
     * 赋权接口的参数 https://confluence.zhihuiya.com/pages/viewpage.action?pageId=272192900
     * @returns
     */
    getTrackingParams() {
        return {
            source: InitCookie.getCampaignName(),
            // 这个要从InitCookie上去,有可能其他团队存的,我这里取,不能支持接使用this.getEntryChannel()
            entry_channel: InitCookie.getEntryChannel(),
            product_source: this.productSource(),
        };
    }
}

export const initCookieService = new InitCookieService();
